// Open contact form modal
var closeTrigger = $('.js-contact-close');
var openContactTrigger = $('.p-solutions__contact-button');
var openContactTriggerNav = $('.js-contact-nav');
var contactModal = $('.c-contact-modal');
var openNavTrigger = $('#js-burger-trigger');
var navSmartphone = $('.l-smartphone-nav__items');
var navSmartphoneContactTrigger = $('.js-nav-contact-trigger');

closeTrigger.on('click', function() {
  contactModal.toggleClass('is-opened');
});

openContactTrigger.on('click', function() {
  contactModal.toggleClass('is-opened');
});

openContactTriggerNav.on('click', function() {
  contactModal.toggleClass('is-opened');
});

openNavTrigger.on('click', function() {
  navSmartphone.toggleClass('is-opened');
  contactModal.removeClass('is-opened');
});

navSmartphoneContactTrigger.on('click', function() {
  navSmartphone.removeClass('is-opened');
  contactModal.addClass('is-opened');
});

// Fixed Nav Home
$(window).scroll(function() {
  var scrollTop = $(window).scrollTop();

  if(scrollTop > 150) {
    $('.l-fixed-nav__in-home').removeClass('is-hidden');
  } else {
    $('.l-fixed-nav__in-home').addClass('is-hidden');
  }
});
